import React, { Children } from "react";
import styled from "styled-components";

interface Props {
	children?: React.ReactNode;
	className?: string;
}
const Wrap = styled.div`
	position: absolute;
	top: 0;
	bottom: 0;
	width: 100%;
	display: grid;
	grid-template-columns: repeat(auto-fill, 1rem);
	grid-template-rows: 1fr;
	justify-content: center;
	margin-inline: auto;
	/*width: min(300em, 90vw);*/
	/* height: 100vh; */
	overflow: hidden;
`;
const Frame = styled.div`
	grid-column: 1 / -1;
	position: relative;
`;

const RemBasedFrame: React.FC<Props> = (props) => {
	const { children, className } = props;
	return (
		<Wrap className={className}>
			<Frame>{children}</Frame>
		</Wrap>
	);
};

export default styled(RemBasedFrame)``;
